export const defaultFetchOptions: RequestInit = {
  credentials: "include",
  headers: {
    ...(process.env.REACT_APP_X_API_KEY && {
      "X-API-KEY": process.env.REACT_APP_X_API_KEY,
    }),
  },
};
